import type { Rotina } from "@/types/pagesMenu";

/** Painéis de consulta liberados no menu do coletor. */
export const rotinasAcompanhamentos: Rotina[] = [{
	categoria: "Acompanhamentos",
	label: "Separação",
	nome: "mni_AcompanhamentoSeparacao",
	rotina: "acompanhamento/separacao-coletor",
	tela: "acompanhamento/separacao-coletor",
	disponivel: true,
}];
